import * as RasaInput from '../../../components/rasa-input'
import * as FilterGroup from '../../filter-group'
import * as Constants from './constants'
import * as Types from './types'

export const filtered = (
  filters: Types.Filter[],
  filterType: Types.FilterType,
  sourceType: Types.SourceType,
): Types.Filter[] => filters.filter((f) => f.filter_source === sourceType && f.filter_type === filterType)

export const requestEvent = (filterType: Types.FilterType, sourceType: Types.SourceType) =>
  `${Constants.FETCH_FILTERS}_${filterType}_${sourceType}`

export const updateStatusEvent = (filterType: Types.FilterType, sourceType: Types.SourceType) =>
  `${Constants.UPDATE_FILTER}_${filterType}_${sourceType}`

export const toggleModalEvent = (filterType: Types.FilterType, sourceType: Types.SourceType) =>
  `${Constants.ADD_FILTERS}_${filterType}_${sourceType}`

export const modalStateValid = (state: Types.AddFilterData): boolean =>
  (state.tags !== '' || state.filter_group_id > 0) && state.filter_source !== '' && state.filter_type !== ''

export const emptyFilterModalState =
  (filterType: Types.FilterType, sourceType: Types.SourceType): Types.AddFilterData => {
  return {
    filter_group_id: 0,
    filter_source: sourceType,
    filter_type: filterType,
    group_name: '',
    tags: '',
    weight: 1,
  }
}

export const filterTypesAsModalDropdown = (): RasaInput.DropdownOption[] =>
  [
    {description: 'Include List', key: Constants.TYPE_INCLUDED},
    {description: 'Exclude List', key: Constants.TYPE_EXCLUDED},
  ]

export const sourceTypesAsModalDropdown = (): RasaInput.DropdownOption[] =>
  [
    {description: 'Individual Tags', key: Constants.SOURCE_TAG},
    {description: 'Tag Group', key: Constants.SOURCE_GROUP},
  ]

export const filterGroupsAsModalDropdown = (filterGroups: FilterGroup.FilterGroup[]): RasaInput.DropdownOption[] =>
  [{key: '-1', description: 'Add a new group'}].concat(filterGroups.map((fg) => ({
    description: fg.name + ' (' + fg.tags.filter((t) => t.is_active).length + ' tags)',
    key: '' + fg.id,
  })))



// WEBPACK FOOTER //
// ./src/pages/source-config/filters/utils.ts